export const getCleanPayload = (payload: Record<string, any>, ignoreFields?: Record<string, any>): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(payload).map(([key, value]) => {
      if (value === undefined && !ignoreFields?.[key]) {
        return [key, undefined];
      }

      const isObject = typeof value === 'object' &&
        value !== null &&
        !(value instanceof File) &&
        !(value instanceof Blob) &&
        !(value instanceof Date);

      const isArray = Array.isArray(value);

      if (isObject && !isArray) {
        const cleanedObject = getCleanPayload(value, ignoreFields?.[key]);

        if (Object.keys(cleanedObject).length === 0) {
          return [key, undefined];
        }

        return [key, cleanedObject];
      }

      if (isArray) {
        const cleanedArray = value
          .map((item) => getCleanPayload(item, ignoreFields?.[key]))
          .filter((item) => item !== undefined);

        if (cleanedArray.length === 0) {
          return [key, undefined];
        }

        return [key, cleanedArray];
      }

      return [key, value];
    }).filter(([key, value]) => !(value === undefined && !ignoreFields?.[key]))
  );
}
